import React, { useContext } from "react";
import { observer } from "mobx-react";

import Title from "./components/Title";
import OfferGroup from "./components/OfferGroup";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import LinkActiveEventsHOC from "./LinkActiveEventsHOC";
import { BetSlipShare } from "@models";

export default observer(function EventOfferGroups(props: {
	groupHasTitle?: boolean;
	titleHasScore?: boolean;
	offersHaveColor?: boolean;
}) {
	const {
		groupHasTitle = false,
		titleHasScore = false,
		offersHaveColor = false,
	} = props;

	const bet = useContext(MyBetsBetContext);

	if (bet instanceof BetSlipShare) {
		return null;
	}

	return (
		<>
			{bet.groupedOffersByEvent.map((offerGroup) => {
				return (
					<div key={offerGroup[0].eventId} className="bet__item">
						<LinkActiveEventsHOC
							className="bet__team bet__link"
							offer={offerGroup[0]}
						>
							<Title
								offer={offerGroup[0]}
								groupHasTitle={groupHasTitle}
								titleHasScore={titleHasScore}
							/>
							<OfferGroup
								offerGroup={offerGroup}
								groupHasTitle={groupHasTitle}
								offersHaveColor={offersHaveColor}
							/>
						</LinkActiveEventsHOC>
					</div>
				);
			})}
		</>
	);
});
